export class PhysicalFinding {
  date?: string;
  diastolic_coding_id?: number;
  firstname?: string;
  version_id?: number;
  lastname?: string;
  dt?: string;
  diastolic?: string;
  systolic?: string;
  user_id?: string;
  patient_id?: number;
  systolic_coding_id?: number;
  version_status?: string;
  status?: number;
  [key: string]: any;
}
